export enum TypeSaveCard {
  LOCAL = 'Local',
  INTERNATIONAL = 'International'
};
